__turbopack_context__.v({
  "facetRow": "Facets-module__-IV6Aa__facetRow",
  "title": "Facets-module__-IV6Aa__title",
});
